function H1(props: any) {
  return (
    <div className={"loop-h1" + (props.color ? " loop-text-color-" + props.color : "") + (props.className ? " " + props.className : "")}>{props.children}</div>
  )
}
function H2(props: any) {
  return (
    <div className={"loop-h2" + (props.color ? " loop-text-color-" + props.color : "") + (props.className ? " " + props.className : "")}>{props.children}</div>
  )
}
function H3(props: any) {
  return (
    <div id={props?.id ? props?.id : ''} className={"loop-h3" + (props.color ? " loop-text-color-" + props.color : "") + (props.className ? " " + props.className : "")}>{props.children}</div>
  )
}

export default Object.assign({}, {
  H1: H1,
  H2: H2,
  H3: H3,
});
